// extracted by mini-css-extract-plugin
export default {"dialog":"LinkMailboxDialog_dialog__1GFWj"};